import React from 'react';

const toneClass = {
  ok: 'cc-chip cc-chip-ok',
  warn: 'cc-chip cc-chip-warn',
  danger: 'cc-chip cc-chip-danger',
  info: 'cc-chip cc-chip-info',
  neutral: 'cc-chip cc-chip-neutral',
};

export default function StatusBadge({ tone = 'neutral', children }) {
  return <span className={toneClass[tone] || toneClass.neutral}>{children}</span>;
}
